import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDatepicker, MatDialog, PageEvent } from '@angular/material';
import { ChartOptions } from 'chart.js';
import { ToastrService } from 'ngx-toastr';
import { AnalyticService } from '../../services/analytic.service';
import { ExportCsvDialog } from './export-csv.dialog';

@Component({
  selector: 'analytics-component',
  templateUrl: './analytic.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AnalyticComponent {
  /******** Analytics *****************/
  @ViewChild('monthPicker') public monthPicker: MatDatepicker<Date>;
  @ViewChild('startDatePicker') public startDatePicker: MatDatepicker<Date>;
  @ViewChild('endDatePicker') public endDatePicker: MatDatepicker<Date>;
  // public contentsFiltered: Observable<Content[]>
  // public contentSearch

  @Input('groupId') public groupId;
  @Input('deviceId') public deviceId;
  @Input('stat') public stat = { content: [], browser: [], os: [], username: [], role: [], noDataByFilters: false };
  @Input('deviceFilter') public deviceFilter;
  @Input('selectedSyncStatus') public selectedSyncStatus;
  @Input('selectedVersions') public selectedVersions;
  public filterDateOpt = 1;
  public contentFilter: string;
  public monthDate;
  public timeoutSearch;
  public loading = true;

  // initialization
  public bgColors = [
    'rgba(0,143,122, 0.8)',
    'rgba(132,94,194, 0.8)',
    'rgba(0,129,207, 0.8)',
    'rgba(50, 255, 50, 0.8)',
    'rgba(255, 50, 50, 0.8)',
    'rgba(50, 50, 255, 0.8)',
  ];
  public pieChartOptions: ChartOptions = {
    // responsive: true,
    // maintainAspectRatio: false,
    plugins: {
      datalabels: { formatter(value, ctx) { return ctx.chart.data.labels[ctx.dataIndex]; } },
    },
  };
  public mostUsedBrowsers = {
    labels: [], data: [], options: this.pieChartOptions, type: 'pie', legend: false,
    bgColors: [{ backgroundColor: [] }],
  };
  public mostUsedOS = {
    labels: [], data: [], options: this.pieChartOptions, type: 'pie', legend: false,
    bgColors: [{ backgroundColor: [] }],
  };
  public mostActiveUsers = {
    labels: [], data: [], options: this.pieChartOptions, type: 'pie', legend: false,
    bgColors: [{ backgroundColor: [] }],
  };
  public mostActiveUserRoles = {
    labels: [], data: [], options: this.pieChartOptions, type: 'pie', legend: false,
    bgColors: [{ backgroundColor: [] }],
  };
  public mostViewedChart = {
    labels: [],
    data: [],
    type: 'horizontalBar',
    bgColors: [{ backgroundColor: [] }],
    legend: false,
    options: {
      /* tooltips: {
        callbacks: { label: function (tooltipItem) { return tooltipItem.yLabel; } }
      }, */
      legend: {
        display: false,
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: { precision: 0, beginAtZero: true },
          /* afterFit: function (scaleInstance) {
            scaleInstance.width = 200; // sets the labels width
          } */
        }],
        xAxes: [{ ticks: { precision: 0, beginAtZero: true } }],
      },
    },
  };
  public mostViewedPage: PageEvent = { length: null, pageIndex: 0, pageSize: 20 };
  public downloading = false;

  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    private analyticService: AnalyticService,
  ) { }

  public ngOnChanges(changes) {
    if (changes && changes.stat && changes.stat.currentValue) {
      this.loading = false;
      const data = changes.stat.currentValue;
      if (!data) { return this.stat = null; }
      if (!data.browser || !data.username || !data.content || !data.os || !data.role) { return this.stat = null; }
      if (!data.browser.length && !data.content.length && !data.os.length && !data.role.length) {
        // const keys = Object.keys(this.getActiveFilters());
        if (Object.keys(this.getActiveFilters()).length == 1) { // keys.includes('groupId') || keys.includes('deviceId'))
          this.stat = null;
        } else {
          this.stat.noDataByFilters = true;
        }
        return;
      }

      this.stat = data;
      this.prepareAnalytics();
    }
    // this.getAnalytics();
  }
  // analytics functions
  public search(event) {
    if (!this.contentFilter || (event && event.keyCode == 13)) {
      clearTimeout(this.timeoutSearch);
      this.getAnalytics();
      return;
    }

    if (this.timeoutSearch) {
      clearTimeout(this.timeoutSearch);
    }
    this.timeoutSearch = setTimeout(() => {
      this.getAnalytics();
    }, 1000);
  }
  public onDateChange() {
    try {
      const start = this.startDatePicker._selected.getTime();
      const end = this.endDatePicker._selected.getTime();
      if (start && end && start <= end) {
        this.getAnalytics();
      } else {
        this.toastr.error('End date is before start date.');
      }
    } catch (error) {
      if (!this.startDatePicker._selected) { this.startDatePicker.open(); } else if (!this.endDatePicker._selected) { this.endDatePicker.open(); } else { this.toastr.error(error, 'Error reading dates.'); }
    }
  }

  public filterDateOptChange() {
    if (this.filterDateOpt == 1) { this.getAnalytics(); }
    if (this.filterDateOpt == 2) { this.monthPicker.open(); }
    if (this.filterDateOpt == 3) { this.startDatePicker.open(); }
  }
  public chosenMonthHandler(normalizedMonth) {
    this.monthDate = normalizedMonth;
    this.monthPicker.close();
    this.getAnalytics();
  }
  public getBgColors = (length) => {
    if (this.bgColors.length < length) {
      // add more colors
      for (let i = this.bgColors.length; i < length; i++) {
        const c = 'rgba(' + Math.floor(Math.random() * 255) + ', ' + Math.floor(Math.random() * 255) + ', ' + Math.floor(Math.random() * 255) + ', 0.8)';
        this.bgColors.push(c);
      }
    }
    return [{ backgroundColor: this.bgColors }];
  }
  public pageChange(page?: PageEvent) {
    if (page) { this.mostViewedPage = page; }
    const paged = this.stat.content.slice(this.mostViewedPage.pageIndex * this.mostViewedPage.pageSize, (this.mostViewedPage.pageIndex + 1) * this.mostViewedPage.pageSize);
    this.mostViewedChart.labels = paged.map((s) => s.name);
    this.mostViewedChart.data = paged.map((s) => s.clicks);
  }
  public getAnalytics() {
    this.loading = true;
    this.analyticService.getAll(this.getActiveFilters()).subscribe((data) => {
      this.loading = false;
      if (!data) { return this.stat = null; }
      if (!data.browser || !data.username || !data.content || !data.os || !data.role) { return this.stat = null; }
      if (!data.browser.length && !data.content.length && !data.os.length && !data.role.length) {
        if (Object.keys(this.getActiveFilters()).length == 1) {
          this.stat = null;
        } else {
          this.stat.noDataByFilters = true;
        }
        return;
      }
      this.stat = data;
      this.prepareAnalytics();
    });
  }
  public prepareAnalytics() {
    /* browsers */
    this.mostUsedBrowsers.bgColors = this.getBgColors(this.stat.browser.length);
    this.mostUsedBrowsers.labels = this.stat.browser.map((s) => s.name);
    this.mostUsedBrowsers.data = this.stat.browser.map((s) => s.clicks);

    /* users */
    this.mostActiveUsers.bgColors = this.getBgColors(this.stat.username.length);
    this.mostActiveUsers.labels = this.stat.username.map((s) => s.name);
    this.mostActiveUsers.data = this.stat.username.map((s) => s.clicks);

    /* role */
    this.mostActiveUserRoles.bgColors = this.getBgColors(this.stat.role.length);
    this.mostActiveUserRoles.labels = this.stat.role.map((s) => s.name);
    this.mostActiveUserRoles.data = this.stat.role.map((s) => s.clicks);

    /* OS */
    this.mostUsedOS.bgColors = this.getBgColors(this.stat.os.length);
    this.mostUsedOS.labels = this.stat.os.map((s) => s.name);
    this.mostUsedOS.data = this.stat.os.map((s) => s.clicks);

    /* content */
    this.mostViewedChart.bgColors = this.getBgColors(this.stat.content.length);
    this.mostViewedPage.length = this.stat.content.length;
    this.pageChange();
  }
  public downloadRawAnalytics() {
    if (this.downloading) { return; }
    this.downloading = true;
    this.dialog.open(ExportCsvDialog, { data: this.getActiveFilters() }).afterClosed().subscribe(() => {
      this.downloading = false;
    });
  }
  private getActiveFilters() {
    const filters: any = {};
    if (this.groupId) { filters.groupId = this.groupId; }
    if (this.deviceId) { filters.deviceId = this.deviceId; }
    // if (this.deviceFilter) filters.device = this.deviceFilter
    if (this.contentFilter) { filters.contentFilter = this.contentFilter; }

    if (this.filterDateOpt == 2 && this.monthDate) {
      const month = new Date(this.monthDate);
      const firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
      const lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0);

      filters.startDate = `${firstDay.getFullYear()}/${firstDay.getMonth() + 1}/${firstDay.getDate()} 00:00`;
      filters.endDate = `${lastDay.getFullYear()}/${lastDay.getMonth() + 1}/${lastDay.getDate()} 23:59`;
    } else if (this.filterDateOpt == 3) {
      if (this.startDatePicker && this.startDatePicker._selected) {
        const startDate = new Date(this.startDatePicker._selected);
        filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
      }
      if (this.endDatePicker && this.endDatePicker._selected) {
        const endDate = new Date(this.endDatePicker._selected);
        filters.endDate = `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()} 23:59`;
      }
    }
    if (this.deviceFilter) { filters.search = this.deviceFilter; }
    if (this.selectedSyncStatus && this.selectedSyncStatus.length) { filters.syncStatus = this.selectedSyncStatus.join(); }
    if (this.selectedVersions && this.selectedVersions.length) { filters.c3Versions = this.selectedVersions.join(); }
    return filters;
  }
}
